import { serviceHelper } from '../config/service-helper';
import { logError } from '../utils/logging';
import { abandonCartFlags } from '../config/enviroment-flags';
import Cookies from 'js-cookie';

export function initKlaviyo() {
  // Init tracking object in case it doesn't exist
  const klaviyoTrack = window._learnq || [];

  // Web tracking
  if (window.Jbhifi.customerEmail) {
    klaviyoTrack.push([
      'identify',
      {
        $email: window.Jbhifi.customerEmail,
      },
    ]);
    klaviyoTrack.push(['account', window.Jbhifi.klaviyoAccount]);
    (function () {
      const b = document.createElement('script');
      b.async = true;
      b.src = `${
        document.location.protocol == 'https:' ? 'https://' : 'http://'
      }a.klaviyo.com/media/js/analytics/analytics.js`;
      const a = document.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(b, a);
    })();
  }

  // Product View tracking
  if (window.Jbhifi.klaviyoProduct) {
    klaviyoTrack.push(['track', 'Viewed Product (Shopify)', window.Jbhifi.klaviyoProduct]);
    klaviyoTrack.push([
      'trackViewedItem',
      {
        Title: window.Jbhifi.klaviyoProduct.Name,
        ItemId: window.Jbhifi.klaviyoProduct.ProductID,
        Categories: window.Jbhifi.klaviyoProduct.Categories,
        ImageUrl: window.Jbhifi.klaviyoProduct.ImageURL,
        Url: window.Jbhifi.klaviyoProduct.URL,
        Metadata: {
          Brand: window.Jbhifi.klaviyoProduct.Brand,
          Price: window.Jbhifi.klaviyoProduct.Price,
          CompareAtPrice: window.Jbhifi.klaviyoProduct.CompareAtPrice,
        },
      },
    ]);
  }

  // Newsletter form
  const addKlaviyoSignupHandler = function ($input, $button, $formContainer) {
    $button.on('click', function (e) {
      e.preventDefault();
      $formContainer.find('.klaviyo-message').remove();
      const email = $input.val();
      const settings = {
        async: true,
        crossDomain: true,
        url: 'https://manage.kmail-lists.com/subscriptions/external/subscribe',
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        data: {
          g: 'MfvrKm',
          $fields: '$source',
          email,
          $source: 'Shopify form',
        },
      };
      $.ajax(settings)
        .done(function (response) {
          if (response.success) {
            $formContainer.append($('<span class="klaviyo-message klaviyo-success">Subscribed!</span>'));
          }
        })
        .fail(function () {
          $formContainer.append(
            $(
              '<span class="klaviyo-message klaviyo-error">It looks like this email address is either invalid or has already subscribed.</span>'
            )
          );
        });
    });
  };

  addKlaviyoSignupHandler($('.newsletter__input'), $('.newsletter__submit'), $('.site-footer__newsletter'));
  addKlaviyoSignupHandler($('.instant-deal--input'), $('.instant-deal--submit'), $('.instant-deal--signup'));
}

export function klaviyoAddedToCart(cart) {
  const klaviyoTrack = window._learnq || [];

  const saveCustomerToAbandonCart = function (email, shopifyCustomerId) {
    $.post(`${serviceHelper.abandonCartSaveCustomer}`, {
      Email: email,
      Id: shopifyCustomerId,
    }).fail(function (xhr, status, error) {
      logError(error, 'Klaviyo: Failed to push latest cart items');
    });
  };

  const cartItems = cart.items.map(item => ({
    Title: item.product_title,
    ImageURL: item.image,
    Url: item.url,
    SKU: item.sku,
    VariantId: item.variant_id,
    Quantity: item.quantity,
  }));

  // Add cart count to cartItems and post to Klaviyo
  cartItems.CartCount = cart.item_count;
  klaviyoTrack.push(['track', 'Added to Cart (Shopify)', cartItems]);

  // push email details to azure function endpoint
  if (abandonCartFlags.abandonCartEnable) {
    if (window.Jbhifi.customerEmail && window.Jbhifi.shopifyCustomerId) {
      saveCustomerToAbandonCart(window.Jbhifi.customerEmail, window.Jbhifi.shopifyCustomerId);
    } else {
      // handling of signed out customers
      const dataCookie = Cookies.get('__kla_id');
      if (dataCookie) {
        const binary = atob(dataCookie.replace(/\s/g, ''));
        const email = JSON.parse(binary).$email;

        if (email) {
          saveCustomerToAbandonCart(email, '');
        }
      }
    }
  }
}
